export default __webpack_public_path__ + "static/vomux_logo-e7da9946745b52fcd5cfd99354e9da1e.svg";